const toArray = (value) => (Array.isArray(value) ? value : []);

export const parseAssignmentPermissions = (raw) => {
    let parsed = raw;
    if (typeof raw === 'string') {
        try {
            parsed = JSON.parse(raw);
        } catch {
            parsed = null;
        }
    }
    const obj = parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    return {
        ...obj,
        addTicket: toArray(obj.addTicket),
        moveOutTicket: toArray(obj.moveOutTicket),
    };
};

// Accepts ids or {value|id} option objects; "*" means every list.
const hasList = (entries, listId) =>
    entries.some((entry) => {
        const id = entry && typeof entry === 'object' ? entry.value ?? entry.id : entry;
        return id === '*' || id === listId;
    });

export const canAddTicketToList = (permissions, listId) =>
    hasList(parseAssignmentPermissions(permissions).addTicket, listId);

export const canMoveTicketOutOfList = (permissions, listId) =>
    hasList(parseAssignmentPermissions(permissions).moveOutTicket, listId);
